/**
 * "Follow Our Journey": echte Instagram-Bilder in den Figma-Kacheln.
 *
 * Anlass: Alex, Pastel #10 (22.09.): "An actual feed from instagram via the plugin we are currently
 * using would be best!" - aber designtreu.
 *
 * Wie: Der Instafeed-App-Block steht unsichtbar in der Section (sections/journey.liquid) und dient nur
 * als Quelle. Sobald er seine Bilder geladen hat, uebernehmen wir die ersten Adressen in die bereits
 * vorhandenen Kacheln .journey__image. Das Raster, die Groessen und die Figma-Knoten bleiben damit
 * unveraendert - nur die Bildquelle wechselt.
 *
 * GOTCHA: Die App setzt Breite und Hoehe ihrer eigenen Kacheln nach jedem Resize per Inline-Stil neu.
 * Ihr Layout mit CSS zu ueberschreiben ist deshalb nicht verlaesslich (gemessen 23.09.2026); nur die
 * Bildadressen zu uebernehmen ist stabil.
 *
 * Faellt die App aus (App entfernt, Netz weg, kein Feed), bleiben die im Theme gepflegten Bilder stehen.
 */
(function () {
  /**
   * Echte Bildadresse. Solange die App-Kacheln unsichtbar sind, steht in `src` nur ihr Platzhalter -
   * die richtige Adresse liegt in `data-instafeed-src` (nachgesehen 23.09.2026).
   */
  function srcOf(img) {
    var s = img.getAttribute('data-instafeed-src') || img.getAttribute('data-src') || img.currentSrc || img.src || '';
    return s.indexOf('//') === 0 ? window.location.protocol + s : s;
  }
  /**
   * Nur echte Beitragsbilder. Die App legt hinter JEDEN Beitrag zusaetzlich ihr eigenes Instagram-Zeichen
   * (instafeed.nfcube.com/assets/img/instagram-icon-v2.svg) und vor dem Laden einen Platzhalter - beides
   * sind Bilder der App, keine Inhalte (gefunden 23.09.2026: damit landete das Logo in der mittleren Kachel).
   */
  function usable(img) {
    var s = srcOf(img);
    if (!s || s.indexOf('data:') === 0) return false;
    if (s.indexOf('instafeed.nfcube.com') !== -1) return false;
    return s.indexOf('placeholder') === -1;
  }

  /** Der App-Block steht neben dem Raster, nicht darin - darum von der ganzen Section aus suchen. */
  function appOf(grid) {
    var root = grid.closest('.journey') || document;
    return root.querySelector('.journey__app');
  }

  function apply(section) {
    var app = appOf(section);
    var boxes = [].slice.call(section.querySelectorAll('.journey__image'));
    if (!app || !boxes.length) return false;
    var imgs = [].slice.call(app.querySelectorAll('img')).filter(usable);
    if (imgs.length < boxes.length) return false;

    boxes.forEach(function (box, i) {
      var from = imgs[i];
      var target = box.querySelector('img');
      if (!target) {
        target = document.createElement('img');
        box.innerHTML = '';
        box.appendChild(target);
      }
      target.removeAttribute('srcset');
      target.removeAttribute('sizes');
      target.src = srcOf(from);
      target.alt = from.alt || '';
      target.loading = 'lazy';
    });
    section.setAttribute('data-journey-instagram', 'geladen');
    return true;
  }

  document.querySelectorAll('[data-journey-instagram]').forEach(function (section) {
    if (apply(section)) return;
    var app = appOf(section);
    if (!app) return;
    // Die App fuellt ihren Container erst spaeter (eigener Netzabruf) - darauf warten, aber nicht ewig.
    var obs = new MutationObserver(function () {
      if (apply(section)) obs.disconnect();
    });
    obs.observe(app, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  });
})();
